import React from 'react';
import { TAppRoutes } from '../../app/features/routes/types/TAppRoute';
import PTestConfig from './pages/PTestConfig';
import PTestError from './pages/PTestError';
import PTestUi from './pages/PTestUi';

const TestRoutes = {
	ui: {
		tag: 'test_ui',
		path: '/test/ui',
		auth: true,
		component: <PTestUi />,
	},
	config: {
		tag: 'test_config',
		path: '/test/config',
		auth: false,
		component: <PTestConfig />,
	},
	error: {
		tag: 'test_error',
		path: '/test/error',
		auth: false,
		component: <PTestError />,
	},
} as TAppRoutes;

export default TestRoutes;
